import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";
import { capabilityForPath } from "@/auth/routeAccess";

// Capability gate for the authenticated area, sitting between ProtectedRoute
// (which answers "is there a session?") and AppLayout. One pathless route covers
// every screen: the path is looked up in the single route→capability table
// (auth/routeAccess) rather than each route restating its own gate, so a screen
// cannot be hidden from the sidebar while still reachable by URL.
//
// A user who lands somewhere they cannot use - a bookmark from a wider role, a
// link from a colleague, a hand-typed URL - goes to the dashboard, which is
// deliberately ungated so this can never loop. `replace` keeps the forbidden URL
// out of history, so Back does not bounce them again.
//
// Session state is already resolved here (ProtectedRoute holds the spinner until
// /auth/me answers), so there is no window where capabilities are unknown and
// this would redirect a permitted user.
export function CapabilityRoute() {
  const { can } = useAuth();
  const { pathname } = useLocation();

  const need = capabilityForPath(pathname);
  if (need && !can(need)) return <Navigate to="/app" replace />;
  return <Outlet />;
}
